import React from "react";
import { Sparkles } from "lucide-react";
import { useLang } from "../lib/LangContext";

export const OfferBanner = () => {
  const { t } = useLang();
  return (
    <div
      data-testid="offer-banner"
      className="bg-lokam-tangerine text-white text-center text-xs md:text-sm font-semibold tracking-wide py-2 px-4 flex items-center justify-center gap-2"
    >
      <Sparkles className="h-3.5 w-3.5 md:h-4 md:w-4" />
      <span>{t.offer}</span>
      <Sparkles className="h-3.5 w-3.5 md:h-4 md:w-4" />
    </div>
  );
};

export default OfferBanner;
